<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="tipoArquivo?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull || (required && !ngModel)">
            {{nullLabel}}
        </option>
        <option *ngFor="let tipoArquivoOption of tiposArquivos" [ngValue]="tipoArquivoOption.id" [disabled]="!tipoArquivoOption.ativo">{{tipoArquivoOption.nome | uppercase}}</option>
    </select>  
</ng-template>